"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _react = _interopRequireWildcard(require("react"));
var _Initialize = _interopRequireDefault(require("./Initialize"));
var _Subscribe = _interopRequireDefault(require("./Subscribe"));
function getLoginStatus(api) {
  var response;
  return _regenerator.default.async(function getLoginStatus$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _regenerator.default.awrap(api.getLoginStatus());
        case 2:
          response = _context.sent;
          return _context.abrupt("return", response.status);
        case 4:
        case "end":
          return _context.stop();
      }
    }
  });
}
var Status = /*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Status, _Component);
  function Status() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      loading: true
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleReady", function _callee(api) {
      return _regenerator.default.async(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = _this;
              _context2.next = 3;
              return _regenerator.default.awrap(getLoginStatus(api));
            case 3:
              _context2.t1 = _context2.sent;
              _context2.t2 = {
                status: _context2.t1,
                loading: false
              };
              _context2.t0.setState.call(_context2.t0, _context2.t2);
            case 6:
            case "end":
              return _context2.stop();
          }
        }
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleStatusChange", function (response) {
      _this.setState({
        status: response.status,
        loading: false
      });
    });
    return _this;
  }
  var _proto = Status.prototype;
  _proto.render = function render() {
    var children = this.props.children;
    var _this$state = this.state,
      status = _this$state.status,
      loading = _this$state.loading;
    return _react.default.createElement(_Initialize.default, {
      onReady: this.handleReady
    }, _react.default.createElement(_Subscribe.default, {
      event: "auth.statusChange",
      onChange: this.handleStatusChange
    }, children({
      status: status,
      loading: loading
    })));
  };
  return Status;
}(_react.Component);
exports.default = Status;